import { render, staticRenderFns } from "./collapse-item.vue?vue&type=template&id=43d3faae&scoped=true&"
import script from "./collapse-item.vue?vue&type=script&lang=js&"
export * from "./collapse-item.vue?vue&type=script&lang=js&"
import style0 from "./collapse-item.vue?vue&type=style&index=0&id=43d3faae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d3faae",
  null
  
)

export default component.exports